import { IApplicationState } from '../../types/redux';

export function getIsLoading(state: IApplicationState) {
  const { tab } = state;

  return state[tab].listing.isLoading;
}
